module.exports = __webpack_public_path__ + "img/logo.e48d08b2.svg";